import axios from 'axios';
import https from 'https';
import Telegram from '../error-handler/helper/Telegram';

const checkHttpsCertificate = process.env.NODE_ENV === 'production';

const proxyAxios = axios.create({
  // baseURL: 'https://www.searates.loc/',
  baseURL: process.env.API_URL,
  httpsAgent: new https.Agent({
    rejectUnauthorized: checkHttpsCertificate,
  }),
  timeout: 180000
});

const jsonHandler = (data: any) => {
  return JSON.stringify(data, null, 2)
    .replace(/_/g, '\_')
    .replace(/\*/g, '\*')
    .replace(/\[/g, '\[')
    .replace(/\]/g, '\]')
    .replace(/\(/g, '\(')
    .replace(/\)/g, '\)')
    .replace(/~/g, '\~')
    .replace(/`/g, '\`')
    .replace(/>/g, '\>')
    .replace(/#/g, '\#')
    .replace(/\+/g, '\+')
    .replace(/-/g, '\-')
    .replace(/=/g, '\=')
    .replace(/\|/g, '\|')
    .replace(/\{/g, '\{')
    .replace(/\}/g, '\}')
    .replace(/\./g, '\.')
    .replace(/!/g, '\!');
}

const statusTexts = ['Unauthorized', 'Forbidden'];
const statusLabelsBlock = ["Your phone number is already verified", "Public email domains are not allowed"]

const errorHandler = async (error: any) => {
  console.log('errorHandler', error.response.data);
  console.log('errorHandler', error.request);
  console.log('errorHandler', error.config.data);
  try {
    if (statusTexts.includes(error?.response?.statusText)) {
      return Promise.reject(error);
    }

    const {password, confirmPassword, ...data} = (error?.config?.data && JSON.parse(error?.config?.data)) || {
      password: '',
      confirmPassword: '',
    };
    if (data['g-recaptcha-response']) delete data['g-recaptcha-response'];

    const path = error.request.path;
    const payload = jsonHandler(data);

    let errorMessage = jsonHandler(error?.response?.data || '')

    if (statusLabelsBlock.some((label) => errorMessage.includes(label))) return Promise.reject(error);

    let string = `
*path:* ${path} \n
*payload:* \`\`\`json\n${payload}\n\`\`\` \n
*response:* \`\`\`json\n${errorMessage}\n\`\`\`
`;

    process.env.NODE_ENV === 'production' && (await new Telegram('error').send(string));
  } catch (e) {
    process.env.NODE_ENV === 'production' && (await new Telegram('error').send(JSON.stringify(e)));
  }

  return Promise.reject(error);
};

proxyAxios.interceptors.request.use((config) => config, errorHandler);
proxyAxios.interceptors.response.use((response) => response, errorHandler);

type TUser = {
  profile: number | string;
  hash: string;
};

export const setToken = (user: TUser) => {
  if (user) {
    const token = getToken(user);
    proxyAxios.defaults.headers.common['Authorization'] = `Basic ${token}`;

    console.log('TOKEN', token);
  }
};

export const getToken = (user: TUser) => {
  return btoa(`${user.profile}:${user.hash}`);
};

export default proxyAxios;
